var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered-layout',{attrs:{"show-leaderboard-ad":true}},[_c('client-only',[(_vm.engagement && _vm.engagement.id)?_c('poll-component',{attrs:{"poll-data":_vm.engagement}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }